import { Box, Typography, Avatar, Card, CardContent } from "@mui/material";
import { useEffect, useRef } from "react";
const testimonials = [
  {
    name: "",
    role: "",
    avatar: "",
    text: "We’ve consistently sourced high-quality spices from Unispeherexim. Their dedication to purity and timely communication makes them a dependable partner.",
  },
  {
    name: "",
    role: "",
    avatar: "",
    text: "Unispeherexim has been our go-to supplier for dehydrated vegetables and powders. Their products are fresh, clean, and always meet our processing standards.",
  },
  {
    name: "",
    role: "",
    avatar: "",
    text: "The quality of onion and garlic powders from Unispeherexim is excellent. Our production team relies on their consistency and transparent sourcing.",
  },
];


const RecentProject = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollAmount = 0;
    const speed = 1; // Adjust scrolling speed

    const scroll = () => {
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
        scrollContainer.scrollLeft = 0;
      } else {
        scrollContainer.scrollLeft += speed;
      }
    };

    const interval = setInterval(scroll, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      style={{
        textAlign: "center",
        padding: "60px 20px",
        backgroundColor: "#D4C9B6",
        borderRadius: "16px",
      }}
    >
      <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "20px" }}>
        What Our Clients Say<br />
        <span style={{ color: "#1F473E" }}>Unispherexim's Global Trust</span>
      </Typography>

      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          overflowX: "auto",
          gap: "20px",
          paddingBottom: "20px",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollBehavior: "smooth",
          whiteSpace: "nowrap",
        }}
      >
        {[...testimonials, ...testimonials].map((testimonial, index) => (
          <Card
            key={index}
            sx={{
              minWidth: "300px",
              maxWidth: "350px",
              flexShrink: 0,
              padding: "20px",
              borderRadius: "16px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              backgroundColor: "#fff",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <CardContent>
              <Avatar src={testimonial.avatar} sx={{ width: 50, height: 50, mb: 2 }} />
              <Typography
                variant="body1"
                sx={{
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  fontSize: "1rem",
                }}
              >
                "{testimonial.text}"
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
                {testimonial.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {testimonial.role}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default RecentProject;
